module.exports = {
  "ppfe-0002": {
    "identifierType": "OTHER",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  },
  "tri-0138": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  }
};